import { useEffect } from "react"
import { Link } from "react-router-dom"
import { say } from "../../helpers/speech"
import { Modal } from "../ui/modal/Modal"
import { useTranslation } from "react-i18next"

const ModalGanaste = ({ show, steps }) => {
  const { t } = useTranslation()

  useEffect(() => {
    if (show[0]) say(t("modals.game_done.you_did_it"))

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show])

  const footerModalEjemplo = () => {
    const handleRetry = () => {
      if (steps) steps.goTo(0)
      show[1](false)
    }
    return (
      <>
        <Link to="/">
          <button type="button" className="btn btn-secondary me-2">
            {t(`ui.btns.back_to_home`)}
          </button>
        </Link>
        {steps && (
          <button
            type="button"
            onClick={handleRetry.bind(this)}
            className="btn btn-primary">
            {t(`ui.btns.try_again`)}
          </button>
        )}
      </>
    )
  }

  return (
    <Modal
      show={show}
      header={<center>{t(`modals.game_done.title`)}</center>}
      body={
        <center>
          <h3>{t(`modals.game_done.body`)}</h3>
        </center>
      }
      footer={footerModalEjemplo()}
    />
  )
}

export { ModalGanaste }
